import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { SignOff } from "@/components/site/SignOff";
import { Thinkers } from "@/components/site/Thinkers";
import { Feature } from "@/components/site/Feature";
import { TopicList } from "@/components/site/TopicList";
import { Dawkins } from "@/components/site/Dawkins";
import { Connect } from "@/components/site/Connect";
import { Seo } from "@/components/site/Seo";

const DESC = "Explore science, rational thinking, scientific skepticism, philosophy and sentientism. Evidence, reason and curiosity for everyone who asks questions.";

export default function Home() {
  return (
    <main>
      <Seo title="Science, Skepticism & Wonder | The Desi Science Page" description={DESC} path="/" />
      <Hero />
      <Marquee />
      <About />
      <SignOff />
      <Thinkers />
      <Feature />
      <TopicList />
      <Dawkins />
      <Connect />
    </main>
  );
}
